export const SET_COLLECTION_VIEW_GRID = 'SET_COLLECTION_VIEW_GRID'
export const SET_COLLECTION_VIEW_LIST = 'SET_COLLECTION_VIEW_LIST'

export const GRID_VIEW = 'grid'
export const LIST_VIEW = 'list'

export const initialState = {
  collectionView: GRID_VIEW
}

export const preferencesReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_COLLECTION_VIEW_GRID:
      return {
        ...state,
        collectionView: GRID_VIEW
      }
    case SET_COLLECTION_VIEW_LIST:
      return {
        ...state,
        collectionView: LIST_VIEW
      }
    default:
      return state
  }
}
